/** Fallback portal login URLs keyed by portalMetaDataNames[0] when credentials.loginUrl is empty. */
export const TPA_PORTAL_URL_FALLBACKS: Record<string, string> = {
  IHX: "https://app.ihx.in/",
  "STAR HEALTH": "https://provider.starhealth.in/",
  "HEALTH INDIA": "https://healthindia.co.in/",
  HERITAGE: "https://www.heritagehealthonline.com/",
  FHPL: "https://fhpl.net/",
  MEDIASSIT: "https://www.mediassist.in/",
  "MEDI ASSIST": "https://www.mediassist.in/",
};

/** Stages that show Open portal window after section details. */
export const TPA_PORTAL_STAGES: string[] = [
  "PREAUTH",
  "CLAIM",
  "DISCHARGE",
  "BILL AUDIT",
  "SETTLEMENT",
  "PORTAL REGISTRATION",
];

export function normalizePortalName(name?: string | null): string {
  return (name || "")
    .toUpperCase()
    .replace(/-/g, " ")
    .replace(/\s+/g, " ")
    .trim();
}

export function getFallbackPortalUrl(portalName?: string | null): string | null {
  const normalized = normalizePortalName(portalName);
  if (!normalized) return null;

  if (TPA_PORTAL_URL_FALLBACKS[normalized]) {
    return TPA_PORTAL_URL_FALLBACKS[normalized];
  }

  const keys = Object.keys(TPA_PORTAL_URL_FALLBACKS);
  for (let i = 0; i < keys.length; i += 1) {
    const key = keys[i];
    if (normalized.includes(key) || key.includes(normalized)) {
      return TPA_PORTAL_URL_FALLBACKS[key];
    }
  }

  return null;
}

export function isTpaPortalStage(visitStageName?: string | null): boolean {
  const name = (visitStageName || "").toUpperCase().trim();
  if (TPA_PORTAL_STAGES.indexOf(name) !== -1) return true;
  return TPA_PORTAL_STAGES.some((stage) => name.includes(stage));
}

export function formatStageLabel(visitStageName?: string | null): string {
  const name = (visitStageName || "").trim();
  if (!name) return "PORTAL";
  if (name.toUpperCase() === "PREAUTH") return "PRE AUTH";
  return name.toUpperCase();
}

/** Hosts known to set X-Frame-Options / CSP frame-ancestors that refuse EdgePro iframes. */
const EMBED_BLOCKED_HOST_FRAGMENTS = [
  "ihx.in",
  "starhealth.in",
  "healthindia",
  "heritagehealth",
  "fhpl.net",
  "mediassist",
  "medi-assist",
];

/**
 * Most insurer portals refuse to load in a third-party iframe.
 * Returns true when we should skip embed and show Open-in-new-tab instead.
 */
export function isLikelyEmbedBlocked(portalUrl?: string | null): boolean {
  if (!portalUrl) return true;
  try {
    const host = new URL(portalUrl).hostname.toLowerCase();
    return EMBED_BLOCKED_HOST_FRAGMENTS.some((fragment) =>
      host.includes(fragment)
    );
  } catch {
    return true;
  }
}
